import React from 'react';
import { Link } from 'react-router-dom';

const BikashError = () => {
    const searchData = new URLSearchParams(window.location.search)
    const message = searchData.get('message')
    return (
        
       <>
       <div className="flex items-center justify-center h-screen shadow-lg border-2">
      <div className="bg-white p-8 rounded shadow-md">
        <h2 className="text-3xl font-semibold mb-4">Payment Unsuccessful</h2>
        <h5 className='text-primary'>{message}</h5>
        <p className="text-[#a4a4a4]">
          We're sorry, but there was an issue processing your payment. Please try again later or  <Link to="/contact" className='text-primary'>contact support</Link>.
        </p>
       <Link to="/course">
       <button className="mt-6 bg-primary text-[#fff] px-4 py-2 rounded hover:bg-blue-600">
          Go Back
        </button>
       </Link>
      </div>
    </div>
       </>
    );
};

export default BikashError;